import React, { useEffect, useState } from "react";
import "./StoryPickerModal.css";
import {
  STORY_LOADERS,
  StoryChoiceId,
  loadStoryCoverImageUrl,
} from "../models/story";

type Props = {
  onClose: () => void;
  onSelectStory: (id: StoryChoiceId) => void;
};

const StoryPickerModal = (props: Props) => {
  const { onClose, onSelectStory } = props;
  const [coverUrls, setCoverUrls] = useState<
    Partial<Record<StoryChoiceId, string>>
  >({});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const entries = await Promise.all(
        STORY_LOADERS.map(async (c) => {
          const url = await loadStoryCoverImageUrl(c.id);
          return [c.id, url] as const;
        })
      );
      if (!cancelled) {
        setCoverUrls(Object.fromEntries(entries) as Record<StoryChoiceId, string>);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      className="StoryPickerOverlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="story-picker-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="StoryPickerPanel" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="StoryPickerClose"
          onClick={onClose}
          aria-label="Close"
        >
          &#x2715;
        </button>
        <h2 id="story-picker-title" className="StoryPickerTitle">
          Choose a story
        </h2>
        <div
          className="StoryPickerList"
          role="list"
          aria-label="Story choices"
        >
          {STORY_LOADERS.map((choice) => (
            <button
              key={choice.id}
              type="button"
              className="StoryPickerOption"
              role="listitem"
              onClick={() => onSelectStory(choice.id)}
            >
              <span
                className={
                  coverUrls[choice.id]
                    ? "StoryPickerCoverWrap"
                    : "StoryPickerCoverWrap StoryPickerCoverWrap--loading"
                }
              >
                {coverUrls[choice.id] ? (
                  <img
                    className="StoryPickerCover"
                    src={coverUrls[choice.id]}
                    alt=""
                  />
                ) : null}
              </span>
              <span className="StoryPickerOptionTitle">{choice.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoryPickerModal;
